





























import { Inject, Component, Vue } from 'vue-property-decorator'
import { WinckOffice } from '@/api/client/winck-proxy'
import { v4 as uuid } from 'uuid'
import { namespace } from 'vuex-class'
const narrowcasting = namespace('narrowcasting')

@Component
export default class CompanySettingsNarrowcastingOfficesCreate extends Vue {
    @Inject() readonly navigateToList: () => Promise<void>
    @narrowcasting.State readonly saving!: boolean
    @narrowcasting.State readonly offices!: WinckOffice[]
    @narrowcasting.Action readonly createOffice: (office: WinckOffice) => Promise<void>
    name: string = null

    async onSave(): Promise<void> {
        await this.createOffice(new WinckOffice(
            uuid(),
            this.name,
        ))

        await this.navigateToList()
    }

    async onCancel(): Promise<void> {
        await this.navigateToList()
    }
}
